import get from "lodash.get";

import XHTTP from "services/api/xhttp";
import CommonUtils from "services/common/utils";

import paths from "routes/paths";

class FlowApi {
  static END_POINTS = {
    getGeneralStats: (id, type) =>
      get(paths, `api.flow.stats.${type}.general`, "").replace(":id", id),
    getDetailsStats: (id, type) =>
      get(paths, `api.flow.stats.${type}.details`, "").replace(":id", id),
    getDistributionStats: (id, type) =>
      get(paths, `api.flow.stats.path.distribution`, "").replace(":id", id),
    getAttendanceGraph: (id, type) =>
      get(paths, `api.flow.stats.${type}.graph.attendance`, "").replace(
        ":id",
        id
      ),
    getTravelTimeGraph: (id, type) =>
      get(paths, `api.flow.stats.path.graph.travelTime`, "").replace(":id", id),
    getChronologyGraph: (id, type) =>
      get(paths, `api.flow.stats.${type}.graph.chronology`, "").replace(
        ":id",
        id
      ),
    getTrafficStats: (id) =>
      get(paths, `api.flow.stats.traffic.at`, "").replace(":id", id),

    getTrafficGraph: (id) =>
      get(paths, `api.flow.stats.traffic.graph.chronology`, "").replace(
        ":id",
        id
      ),

    getTrafficGeneralStats: (id) =>
      get(paths, `api.flow.stats.traffic.general`, "").replace(":id", id),
  };

  static getTrafficStats(id, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);
    return XHTTP(`${FlowApi.END_POINTS.getTrafficStats(id)}?${queryString}`, {
      method: "get",
    });
  }

  static getTrafficGraph(id, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);
    return XHTTP(`${FlowApi.END_POINTS.getTrafficGraph(id)}?${queryString}`, {
      method: "get",
    });
  }

  static getTrafficGeneralStats(id, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject({
      from: filters.from,
      to: filters.to,
      duration_unit: filters.duration_unit,
    });
    return XHTTP(
      `${FlowApi.END_POINTS.getTrafficGeneralStats(id)}?${queryString}`,
      {
        method: "get",
      }
    );
  }

  static getGeneralStats(id, type, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${FlowApi.END_POINTS.getGeneralStats(id, type)}?${queryString}`,
      {
        method: "get",
      }
    );
  }

  static getDetailsStats(id, type, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${FlowApi.END_POINTS.getDetailsStats(id, type)}?${queryString}`,
      {
        method: "get",
      }
    );
  }

  static getDistributionStats(id, type, filters, data) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${FlowApi.END_POINTS.getDistributionStats(id, type)}?${queryString}`,
      {
        method: "post",
        body: JSON.stringify(data),
      }
    );
  }

  static getAttendanceGraph(id, type, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${FlowApi.END_POINTS.getAttendanceGraph(id, type)}?${queryString}`,
      {
        method: "get",
      }
    );
  }

  static getTravelTimeGraph(id, type, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${FlowApi.END_POINTS.getTravelTimeGraph(id, type)}?${queryString}`,
      {
        method: "get",
      }
    );
  }

  static getChronologyGraph(id, type, filters) {
    const queryString = CommonUtils.buildQueryStringFromObject(filters);

    return XHTTP(
      `${FlowApi.END_POINTS.getChronologyGraph(id, type)}?${queryString}`,
      {
        method: "get",
      }
    );
  }
}

export default FlowApi;
